import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectProductionPlantsListItems } from "../../../../../../redux/production-plants/selector";
import { productionPlants } from "../../../../../../redux/production-plants/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementProductionPlants = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const productionPlantItems = useSelector(selectProductionPlantsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'ProductionPlantInfo.Name', headerName: 'Name' },
          { field: 'ProductionPlantInfo.PhoneNumber', headerName: 'Phone Number' },
          { field: 'ProductionPlantInfo.IsPrimaryProductionPlant', headerName: 'PrimaryProductionPlant', cellRenderer: 'yesNoRenderer' },
          { field: 'ProductionPlantInfo.SslEnabled', headerName: 'SslEnabled', cellRenderer: 'yesNoRenderer' },
          { field: 'ProductionPlantInfo.IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
      const fetchProductionPlants=()=>{

        dispatch(productionPlants.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-plants/list`,entity:'productionPlants',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchProductionPlants()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add ProductionPlants',
      callback: () => handleAdd(),
    },
    {
      name: 'Go To ProductionUnits',
      callback: () => handleProductionUnits(),
    }
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleProductionUnits=()=>{
    navigate('/management/organization/organization-management/production-units')
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.ProductionPlantInfo?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(productionPlants.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-plants/delete`,
      entity: 'productionPlants',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(productionPlants.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-plants/list`,entity:'productionPlants',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {productionPlantItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={productionPlantItems?.result?.items} setPageData={setPageData}
    paginationData={productionPlantItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Production Plants"  />
  }
  </> 
     
	);
};

export default ManagementProductionPlants;


